OE.addPlugin('CopyToClipboard', (function() {
  var Plugin = {},
    Options = {},
    dataAttributeName = 'data-copy-to-clipboard';

  Plugin.init = function() {
    OE.Utils.delegateEvent(
      CLICK,
      docEventListener,
      '[' + dataAttributeName + ']'
    );
  };

  var docEventListener = function(e) {
    var clicked = this;
    var input = clicked;
    var successful = false;

    try { window.clearTimeout(clicked.timer); } catch( Ex ) { };
    clicked.classList.remove('has--copied');

    if (input.hasAttribute(dataAttributeName)) {
      var selector = input.getAttribute(dataAttributeName);

      if (selector) {
        input = document.querySelector(selector);
      }

      if (input) {
        input.select();

        try {
          successful = document.execCommand('copy');
        } catch (err) {}
      }
    }

    if (!successful) {
      clicked.classList.add('cannot-copy');
    }
    else
    {
      clicked.classList.add('has--copied');
      clicked.timer = window.setTimeout(function() { this.classList.remove( 'has--copied' ); }.bind( clicked ), 500 );
    }
  };

  return Plugin;
})());
